import { render } from "./KaffeemaschinenFinderApp.vue?vue&type=template&id=2775bdbb&scoped=true"
import script from "./KaffeemaschinenFinderApp.vue?vue&type=script&lang=js"
export * from "./KaffeemaschinenFinderApp.vue?vue&type=script&lang=js"

import "./KaffeemaschinenFinderApp.vue?vue&type=style&index=0&id=2775bdbb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2775bdbb"]])

export default __exports__